var _circle, _path, _g, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _g2, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _mask, _g3, _circle2, _g4, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _rect47, _rect48, _rect49, _rect50, _rect51, _rect52, _rect53, _rect54, _rect55, _rect56, _rect57, _rect58, _rect59, _rect60, _rect61, _rect62, _path2, _path3, _path4, _circle3, _circle4, _path5, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEmptyDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 128,
    cy: 128,
    r: 128,
    fill: "#E5E8F0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77 83C74.2386 83 72 85.2386 72 88V104V165V178C72 180.761 74.2386 183 77 183H183.725C186.591 183 188.871 180.595 188.718 177.733L184.754 103.733C184.611 101.079 182.418 99 179.761 99H146.943L144.753 87.0956C144.317 84.7228 142.248 83 139.836 83H109.4H77Z",
    fill: "#8C9EB2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M110.682 41.9693C110.987 39.2248 113.46 37.248 116.205 37.5538L141.195 40.3387L172.08 43.7805C174.824 44.0863 176.801 46.5591 176.495 49.3035L167.367 131.215C167.061 133.96 164.589 135.936 161.844 135.631L105.969 129.404C103.224 129.098 101.248 126.625 101.553 123.881L110.682 41.9693Z",
    fill: "white"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 113.918,
    y: 63.4295,
    width: 23.742,
    height: 18.6481,
    rx: 2.5,
    transform: "rotate(6.35878 113.918 63.4295)",
    fill: "#DFDFDF",
    stroke: "#DFDFDF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 110.967,
    y: 85.3911,
    width: 48.0286,
    height: 2.91082,
    rx: 1,
    transform: "rotate(6.26215 110.967 85.3911)",
    fill: "#DFDFDF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 162.327,
    y: 91.0247,
    width: 2.91082,
    height: 2.91082,
    rx: 1,
    transform: "rotate(6.26215 162.327 91.0247)",
    fill: "#DFDFDF"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 160.07,
    y: 111.275,
    width: 2.91082,
    height: 2.91082,
    rx: 1,
    transform: "rotate(6.26215 160.07 111.275)",
    fill: "#DFDFDF"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 161.198,
    y: 101.15,
    width: 2.91082,
    height: 2.91082,
    rx: 1,
    transform: "rotate(6.26215 161.198 101.15)",
    fill: "#DFDFDF"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 158.861,
    y: 122.124,
    width: 2.91082,
    height: 2.91082,
    rx: 1,
    transform: "rotate(6.26215 158.861 122.124)",
    fill: "#DFDFDF"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 161.764,
    y: 96.074,
    width: 2.91082,
    height: 2.91082,
    rx: 1,
    transform: "rotate(6.26215 161.764 96.074)",
    fill: "#DFDFDF"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 159.507,
    y: 116.324,
    width: 2.91082,
    height: 2.91082,
    rx: 1,
    transform: "rotate(6.26215 159.507 116.324)",
    fill: "#DFDFDF"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 160.636,
    y: 106.199,
    width: 2.91082,
    height: 2.91082,
    rx: 1,
    transform: "rotate(6.26215 160.636 106.199)",
    fill: "#DFDFDF"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 158.297,
    y: 127.181,
    width: 2.91082,
    height: 2.91082,
    rx: 1,
    transform: "rotate(6.26215 158.297 127.181)",
    fill: "#DFDFDF"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 109.84,
    y: 95.5029,
    width: 48.0286,
    height: 2.91082,
    rx: 1,
    transform: "rotate(6.26215 109.84 95.5029)",
    fill: "#DFDFDF"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 108.712,
    y: 105.628,
    width: 48.0286,
    height: 2.91082,
    rx: 1,
    transform: "rotate(6.26215 108.712 105.628)",
    fill: "#DFDFDF"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 107.502,
    y: 116.477,
    width: 48.0286,
    height: 2.91082,
    rx: 1,
    transform: "rotate(6.26215 107.502 116.477)",
    fill: "#DFDFDF"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 110.404,
    y: 90.4404,
    width: 48.0286,
    height: 2.91082,
    rx: 1,
    transform: "rotate(6.26215 110.404 90.4404)",
    fill: "#DFDFDF"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 109.278,
    y: 100.552,
    width: 48.0286,
    height: 2.91082,
    rx: 1,
    transform: "rotate(6.26215 109.278 100.552)",
    fill: "#DFDFDF"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 108.15,
    y: 110.677,
    width: 48.0286,
    height: 2.91082,
    rx: 1,
    transform: "rotate(6.26215 108.15 110.677)",
    fill: "#DFDFDF"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 106.938,
    y: 121.539,
    width: 48.0286,
    height: 2.91082,
    rx: 1,
    transform: "rotate(6.26215 106.938 121.539)",
    fill: "#DFDFDF"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 115.813,
    y: 41.9033,
    width: 56.0334,
    height: 2.91082,
    rx: 1,
    transform: "rotate(6.35878 115.813 41.9033)",
    fill: "#D3DFEA"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 115.25,
    y: 46.9661,
    width: 56.0334,
    height: 2.91082,
    rx: 1,
    transform: "rotate(6.35878 115.25 46.9661)",
    fill: "#D3DFEA"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 114.686,
    y: 52.0288,
    width: 56.0334,
    height: 2.91082,
    rx: 1,
    transform: "rotate(6.35878 114.686 52.0288)",
    fill: "#D3DFEA"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 114.121,
    y: 57.0913,
    width: 50.9394,
    height: 2.91082,
    rx: 1,
    transform: "rotate(6.35878 114.121 57.0913)",
    fill: "#D3DFEA"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 139.832,
    y: 69.4756,
    width: 28.3805,
    height: 2.91082,
    rx: 1,
    transform: "rotate(6.35878 139.832 69.4756)",
    fill: "#DFDFDF"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 139.268,
    y: 74.5381,
    width: 28.3805,
    height: 2.91082,
    rx: 1,
    transform: "rotate(6.35878 139.268 74.5381)",
    fill: "#DFDFDF"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 138.705,
    y: 79.6006,
    width: 25.4697,
    height: 2.91082,
    rx: 1,
    transform: "rotate(6.35878 138.705 79.6006)",
    fill: "#DFDFDF"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M78.6712 66.8447C78.3005 64.1082 80.2183 61.5894 82.9547 61.2187L107.872 57.8431L138.667 53.6712C141.403 53.3005 143.922 55.2183 144.293 57.9548L155.357 139.627C155.728 142.364 153.81 144.883 151.074 145.253L95.3615 152.801C92.6251 153.171 90.1062 151.254 89.7355 148.517L78.6712 66.8447Z",
    fill: "white"
  }))), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 86.7119,
    y: 88.251,
    width: 56.0334,
    height: 14.5541,
    rx: 3,
    transform: "rotate(-7.71497 86.7119 88.251)",
    fill: "#D3DFEA"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 123.606,
    y: 123.776,
    width: 23.742,
    height: 18.6481,
    rx: 2.5,
    transform: "rotate(-7.71497 123.606 123.776)",
    fill: "#DFDFDF",
    stroke: "#DFDFDF"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 89.5699,
    y: 105.622,
    width: 55.0334,
    height: 1.91082,
    rx: 0.5,
    transform: "rotate(-7.71497 89.5699 105.622)",
    fill: "#DFDFDF",
    stroke: "#DFDFDF"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 92.6964,
    y: 128.698,
    width: 27.3805,
    height: 1.91082,
    rx: 0.5,
    transform: "rotate(-7.71497 92.6964 128.698)",
    fill: "#DFDFDF",
    stroke: "#DFDFDF"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 90.2535,
    y: 110.67,
    width: 55.0334,
    height: 1.91082,
    rx: 0.5,
    transform: "rotate(-7.71497 90.2535 110.67)",
    fill: "#DFDFDF",
    stroke: "#DFDFDF"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 93.3795,
    y: 133.746,
    width: 27.3805,
    height: 1.91082,
    rx: 0.5,
    transform: "rotate(-7.71497 93.3795 133.746)",
    fill: "#DFDFDF",
    stroke: "#DFDFDF"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 90.9371,
    y: 115.718,
    width: 55.0334,
    height: 1.91082,
    rx: 0.5,
    transform: "rotate(-7.71497 90.9371 115.718)",
    fill: "#DFDFDF",
    stroke: "#DFDFDF"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 94.0621,
    y: 138.794,
    width: 27.3805,
    height: 1.91082,
    rx: 0.5,
    transform: "rotate(-7.71497 94.0621 138.794)",
    fill: "#DFDFDF",
    stroke: "#DFDFDF"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 94.7477,
    y: 143.842,
    width: 17.9204,
    height: 1.91082,
    rx: 0.5,
    transform: "rotate(-7.71497 94.7477 143.842)",
    fill: "#DFDFDF",
    stroke: "#DFDFDF"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 91.6217,
    y: 120.766,
    width: 27.3805,
    height: 1.91082,
    rx: 0.5,
    transform: "rotate(-7.71497 91.6217 120.766)",
    fill: "#DFDFDF",
    stroke: "#DFDFDF"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 83.6348,
    y: 67.3455,
    width: 24.651,
    height: 19.3687,
    rx: 3,
    transform: "rotate(-7.71497 83.6348 67.3455)",
    fill: "#BACBDB"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 110.805,
    y: 66.3364,
    width: 28.3805,
    height: 2.91082,
    rx: 1,
    transform: "rotate(-7.71497 110.805 66.3364)",
    fill: "#D3DFEA"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 111.488,
    y: 71.3843,
    width: 28.3805,
    height: 2.91082,
    rx: 1,
    transform: "rotate(-7.71497 111.488 71.3843)",
    fill: "#D3DFEA"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 112.173,
    y: 76.4319,
    width: 25.4697,
    height: 2.91082,
    rx: 1,
    transform: "rotate(-7.71497 112.173 76.4319)",
    fill: "#D3DFEA"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 83,
    y: 63,
    width: 28,
    height: 24
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84.4705 70.2148C84.2851 68.8466 85.244 67.5872 86.6122 67.4018L105.094 64.898C106.463 64.7127 107.722 65.6716 107.907 67.0398L109.702 80.2874C109.887 81.6556 108.929 82.9151 107.56 83.1004L89.0781 85.6042C87.7099 85.7896 86.4505 84.8307 86.2652 83.4625L84.4705 70.2148Z",
    fill: "#BACBDB",
    stroke: "#BACBDB"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M93.2069 74.7581C90.4893 78.1772 86.6451 83.0698 85.6392 84.5538C85.4634 84.8132 85.4183 85.1192 85.4604 85.4298L85.8502 88.307C85.9984 89.4016 87.006 90.1687 88.1005 90.0204L111.079 86.9075C112.174 86.7592 112.941 85.7517 112.793 84.6571L112.21 80.3574C112.139 79.8282 111.858 79.3495 111.431 79.0283L107.976 76.426C107.1 75.7665 105.856 75.935 105.188 76.8036L104.18 78.1127C103.511 78.9813 102.268 79.1498 101.392 78.4903L95.9701 74.4075C95.1056 73.7566 93.8802 73.911 93.2069 74.7581Z",
    fill: "#8C9EB2"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 102.249,
    cy: 69.2299,
    r: 2.18312,
    transform: "rotate(-7.71497 102.249 69.2299)",
    fill: "#8C9EB2"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M137.202 65.8779C137.808 63.1839 140.484 61.4917 143.178 62.0983L167.708 67.6214L198.026 74.4473C200.72 75.0538 202.412 77.7294 201.806 80.4234L183.702 160.829C183.096 163.523 180.42 165.215 177.726 164.609L122.878 152.26C120.184 151.653 118.492 148.978 119.098 146.284L137.202 65.8779Z",
    fill: "white"
  }))), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 139.73,
    y: 114.283,
    width: 48.0286,
    height: 2.91082,
    rx: 1,
    transform: "rotate(12.6885 139.73 114.283)",
    fill: "#DFDFDF"
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 126.966,
    y: 134.532,
    width: 55.3056,
    height: 2.91082,
    rx: 1,
    transform: "rotate(12.6885 126.966 134.532)",
    fill: "#DFDFDF"
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 149.936,
    y: 68.9541,
    width: 29.1082,
    height: 2.91082,
    rx: 1,
    transform: "rotate(12.6885 149.936 68.9541)",
    fill: "#D3DFEA"
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 132.299,
    y: 113.122,
    width: 1.91082,
    height: 1.91082,
    rx: 0.5,
    transform: "rotate(12.6885 132.299 113.122)",
    stroke: "#DFDFDF"
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 142.529,
    y: 67.686,
    width: 1.91082,
    height: 1.91082,
    rx: 0.5,
    transform: "rotate(12.6885 142.529 67.686)",
    stroke: "#D3DFEA"
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 131.18,
    y: 118.092,
    width: 1.91082,
    height: 1.91082,
    rx: 0.5,
    transform: "rotate(12.6885 131.18 118.092)",
    stroke: "#DFDFDF"
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    x: 141.411,
    y: 72.6555,
    width: 1.91082,
    height: 1.91082,
    rx: 0.5,
    transform: "rotate(12.6885 141.411 72.6555)",
    stroke: "#D3DFEA"
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    x: 130.062,
    y: 123.061,
    width: 1.91082,
    height: 1.91082,
    rx: 0.5,
    transform: "rotate(12.6885 130.062 123.061)",
    stroke: "#DFDFDF"
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    x: 140.291,
    y: 77.6252,
    width: 1.91082,
    height: 1.91082,
    rx: 0.5,
    transform: "rotate(12.6885 140.291 77.6252)",
    stroke: "#D3DFEA"
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    x: 128.942,
    y: 128.03,
    width: 1.91082,
    height: 1.91082,
    rx: 0.5,
    transform: "rotate(12.6885 128.942 128.03)",
    stroke: "#DFDFDF"
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    x: 139.172,
    y: 82.5947,
    width: 1.91082,
    height: 1.91082,
    rx: 0.5,
    transform: "rotate(12.6885 139.172 82.5947)",
    stroke: "#D3DFEA"
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    x: 136.89,
    y: 113.643,
    width: 0.727706,
    height: 18.1926,
    rx: 0.363853,
    transform: "rotate(12.6885 136.89 113.643)",
    fill: "#C4C4C4"
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    x: 147.121,
    y: 68.2078,
    width: 0.727706,
    height: 18.1926,
    rx: 0.363853,
    transform: "rotate(12.6885 147.121 68.2078)",
    fill: "#8C9EB2"
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    x: 138.611,
    y: 119.252,
    width: 48.0286,
    height: 2.91082,
    rx: 1,
    transform: "rotate(12.6885 138.611 119.252)",
    fill: "#DFDFDF"
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    x: 125.848,
    y: 139.502,
    width: 55.3056,
    height: 2.91082,
    rx: 1,
    transform: "rotate(12.6885 125.848 139.502)",
    fill: "#DFDFDF"
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    x: 148.841,
    y: 73.8164,
    width: 29.1082,
    height: 2.91082,
    rx: 1,
    transform: "rotate(12.6885 148.841 73.8164)",
    fill: "#D3DFEA"
  })), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    x: 137.492,
    y: 124.222,
    width: 48.0286,
    height: 2.91082,
    rx: 1,
    transform: "rotate(12.6885 137.492 124.222)",
    fill: "#DFDFDF"
  })), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    x: 124.728,
    y: 144.472,
    width: 48.0286,
    height: 2.91082,
    rx: 1,
    transform: "rotate(12.6885 124.728 144.472)",
    fill: "#DFDFDF"
  })), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    x: 147.722,
    y: 78.7856,
    width: 29.1082,
    height: 2.91082,
    rx: 1,
    transform: "rotate(12.6885 147.722 78.7856)",
    fill: "#D3DFEA"
  })), _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    x: 136.375,
    y: 129.191,
    width: 48.0286,
    height: 2.91082,
    rx: 1,
    transform: "rotate(12.6885 136.375 129.191)",
    fill: "#DFDFDF"
  })), _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
    x: 146.603,
    y: 83.7551,
    width: 29.1082,
    height: 2.91082,
    rx: 1,
    transform: "rotate(12.6885 146.603 83.7551)",
    fill: "#D3DFEA"
  })), _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
    x: 135.715,
    y: 97.3374,
    width: 54.5844,
    height: 3.52158,
    rx: 1,
    transform: "rotate(12.6885 135.715 97.3374)",
    fill: "#D3DFEA"
  })), _rect61 || (_rect61 = /*#__PURE__*/React.createElement("rect", {
    x: 136.875,
    y: 92.1841,
    width: 54.5844,
    height: 3.52158,
    rx: 1,
    transform: "rotate(12.6885 136.875 92.1841)",
    fill: "#D3DFEA"
  })), _rect62 || (_rect62 = /*#__PURE__*/React.createElement("rect", {
    x: 134.555,
    y: 102.491,
    width: 49.3021,
    height: 3.52158,
    rx: 1,
    transform: "rotate(12.6885 134.555 102.491)",
    fill: "#D3DFEA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M188.138 78.1854C188.137 78.1853 188.137 78.1855 188.137 78.1857L186.445 85.7021C186.408 85.8637 186.51 86.0243 186.672 86.0607L194.188 87.7531C194.189 87.7531 194.189 87.753 194.189 87.7529C195.16 83.44 192.451 79.1565 188.138 78.1854Z",
    fill: "#8C9EB2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M186.593 80.0751C186.594 80.0753 186.594 80.0758 186.594 80.0764L185.142 86.5267C185.106 86.6884 185.207 86.8489 185.369 86.8853L191.819 88.3376C191.819 88.3376 191.819 88.3378 191.819 88.338C190.981 92.0628 187.281 94.4025 183.557 93.5639C179.832 92.7252 177.492 89.0258 178.331 85.301C179.169 81.5762 182.869 79.2365 186.593 80.0751Z",
    fill: "#8C9EB2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72 97C69.2386 97 67 99.2386 67 102V113V185V195C67 197.761 69.2386 200 72 200H184C186.761 200 189 197.761 189 195V113C189 110.239 186.761 108 184 108H147.602L145.911 100.849C145.377 98.5932 143.363 97 141.045 97H109.5H72Z",
    fill: "#BACBDB"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 110.28,
    cy: 142.28,
    r: 5.28,
    fill: "white"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 143.72,
    cy: 142.28,
    r: 5.28,
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M121 162C124.877 166 130.123 166 134 162",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 98.9995,
    y: 35,
    width: 80.0496,
    height: 103.184,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d",
    x: 76,
    y: 51,
    width: 82.0286,
    height: 104.472,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d",
    x: 116,
    y: 59,
    width: 88.9038,
    height: 108.707,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyDashboard);
export default __webpack_public_path__ + "static/media/empty-dashboard.2ba9624c.svg";
export { ForwardRef as ReactComponent };